(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('MedLocation', MedLocation);

    MedLocation.$inject = ['$resource'];

    function MedLocation ($resource) {
        var resourceUrl =  'api/med-locations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
